import { memo } from 'react';

import { ApartmentOutlined } from '@ant-design/icons';

import AddNewRelation from './add-new-relation-group';
import useCreateRelationGroup from './use-create-relation-group';

const EmptyState = memo(() => {
  const { onSelect, isLoading } = useCreateRelationGroup();

  return (
    <div
      className="gx-d-flex gx-align-items-center gx-justify-content-center gx-flex-column"
      style={{ minHeight: '30vh', gap: 12 }}
    >
      <ApartmentOutlined style={{ fontSize: 64, color: '#3da4e6' }} />
      <p className="gx-text-black gx-fs-lg gx-mb-0">Henüz madde eklenmemiş.</p>
      <p className="gx-mb-0">İlişki kurmak istediğiniz bir madde varsa buradan ekleyebilirsiniz.</p>
      <AddNewRelation onSelect={onSelect} isSelecting={isLoading} />
    </div>
  );
});

export default EmptyState;
